// Maintaining a single source for Alert status options.
// adding flags to the options so that its easy to know if each option should be shown for resolution/filter

// Also, added a flag for incident. It should be true if changing to the particular status should ask user for incident value
export const alertStatusOptions = [
    {
        value: "NEW",
        label: "New",
        resolve: false,
        filter: true
    },
    {
        value: "READ",
        label: "Read",
        resolve: false,
        filter: true
    },
    {
        value: "NUISANCE",
        label: "Nuisance",
        resolve: true,
        filter: true
    },
    {
        value: "NUISANCE_TUNING",
        label: "Nuisance (Tuning Needed)",
        resolve: true,
        filter: true
    },
    {
        value: "NUISANCE_RETRAIN",
        label: "Nuisance (Retrain)",
        resolve: true,
        filter: true
    },
    {
        value: "NUISANCE_NO_ACTION",
        label: "Nuisance (No Possible Further Actions)",
        resolve: true,
        filter: true
    },
    {
        value: "ACTION_REQUIRED",
        label: "Action Required",
        resolve: true,
        filter: true
    },
    {
        value: "MAINTENANCE_INVESTIGATION",
        label: "Maintenance Investigation",
        resolve: true,
        filter: true,
        incident: true
    },
    {
        value: "POSSIBLEFAILURE",
        label: "Possible Failure",
        resolve: true,
        filter: true
    },
    {
        value: "FAILURE",
        label: "Failure Event",
        resolve: true,
        filter: true,
        incident: true
    },
    {
        value: "NOT_ASSESSED",
        label: "Not Assessed",
        resolve: true,
        filter: true
    }
];
